import { assertNever } from "@@/shared/assert-never";
import type { Product } from "@@/shared/products/product";
import { isProductId } from "@@/shared/products/product-id";
import type { Page } from "../page";
import { isPageId } from "../page-id";
import type { ContentId } from "./content-id";
import type { CustomContent } from "./custom-content/custom-content";
import { isCustomContentId } from "./custom-content/custom-content-id";

type Content = Page | Product | CustomContent;
type ContentType = Content["_type"];

function getContentType(contentId: ContentId): ContentType;
function getContentType(contentId: undefined): undefined;
function getContentType(
    contentId: ContentId | undefined,
): ContentType | undefined;
function getContentType(
    contentId: ContentId | undefined,
): ContentType | undefined {
    if (!contentId) return undefined;
    if (isPageId(contentId)) return "PAGE";
    if (isProductId(contentId)) return "PRODUCT";
    if (isCustomContentId(contentId)) return "CUSTOM_CONTENT";
    assertNever(contentId);
    throw new Error("Unknown contentId type; " + contentId);
}

export { getContentType };
export type { Content, ContentType };
